import Branding from '../../../components/branding'

const SensorSettingsProbe = sensor => {

  const probeTypes = [
    "J",
    "N",
    "S",
    "E",
    "B",
    "R",
  ];

  const TemplateAF = () => {
    return `
    <div class="setting c-margin-xlg">
      <h3>Pipe Clamp</h3>
      
      <input type="hidden" name="TC_M" value="1" />
      <input type="hidden" name="TC_TYPE" value="K" />
      <input type="hidden" name="TC_R" value="1" />
      
      ${sensor.last_tcTemp === 'n' ? `
        <div class="message--error text--small c-margin-bottom-xlg">
          <b>Warning:</b> Your clamp doesn't appear to be getting readings, please re-insert into your sensor.
        </div>
        
      ` : `Last pipe reading: <b>${window.celsiusToUserTemp(sensor.last_tcTemp, 1)}</b>`}
        
    </div>
    `
  }

  const defaultTemplate = () => {
    return `
    <div class="setting c-margin-xlg">
          
      <h3>Thermocouple Probe</h3>   
      
      <div class="setting__description">
        This sensor supports an external temperature probe, 
        select if you want to use a probe and the probe type you're using
      </div>
      
      ${sensor.TC_M && sensor.TC_M == 1 && sensor.last_tcTemp === 'n' ? `
        <div class="message--error text--small c-margin-bottom-xlg">
          <b>Warning:</b> Your probe doesn't appear to be working, re-insert the probe and verify the right type is selected.
        </div>
        
      ` : ''}
              
      <div class="setting__input">
            
          <div class="setting__switch">
            <div class="setting__switch__value">
              <div class="switch medium">
                <input class="switch-input" type="checkbox" id="TC_M" name="TC_M" value="1" ${sensor.TC_M == 1 ? 'checked' : ''} />
                <label class="switch-paddle" for="TC_M">
                  <span class="switch-active">Yes</span>
                  <span class="switch-inactive">No</span>
                </label>
              </div>
            </div>
            <div class="setting__switch__label">Use Thermocouple Probe</div>
          </div>
  
        </div>
        
        <div class="setting setting--conditional ${sensor.TC_M == 1 ? 'is-active' : ''}" data-for="TC_M">
          
            <div class="setting__input">
              <div class="setting__label">Probe Type:</div>
              <select class="settings-select" name="TC_TYPE">
                <option value="T" ${(!sensor.TC_SKIN || sensor.TC_SKIN === 'DEFAULT') && sensor.TC_TYPE === 'T' ? 'selected' : ''}>T-Type (Blue)</option>
                <option value="K" ${(!sensor.TC_SKIN || sensor.TC_SKIN === 'DEFAULT') && sensor.TC_TYPE === 'K' ? 'selected' : ''}>K-Type (Yellow)</option>
                <option value="BUFFER_BOTTLE" ${sensor.TC_SKIN === 'BUFFER_BOTTLE' ? 'selected' : ''}>Buffer Bottle</option>
                <option value="CLAMP" ${sensor.TC_SKIN === 'CLAMP' ? 'selected' : ''}>Pipe Clamp</option>
                <option value="WINE_BOTTLE" ${sensor.TC_SKIN === 'WINE_BOTTLE' ? 'selected' : ''}>Wine Bottle</option>
                <option value="">-- Other --</option>
                <option value="J" ${sensor.TC_TYPE === 'J' ? 'selected' : ''}>J-Type</option>
                <option value="N" ${sensor.TC_TYPE === 'N' ? 'selected' : ''}>N-Type</option>
                <option value="S" ${sensor.TC_TYPE === 'S' ? 'selected' : ''}>S-Type</option>
                <option value="E" ${sensor.TC_TYPE === 'E' ? 'selected' : ''}>E-Type</option>
                <option value="B" ${sensor.TC_TYPE === 'B' ? 'selected' : ''}>B-Type</option>
                <option value="R" ${sensor.TC_TYPE === 'R' ? 'selected' : ''}>R-Type</option>
              </select>
            </div>
            
            <div class="setting__input">
              <div class="setting__label">Mode:</div>
              <select class="settings-select" name="TC_R">
                <option value="1" ${1 == sensor.TC_R ? 'selected' : ''}>Accuracy Mode</option>
                <option value="0" ${0 == sensor.TC_R ? 'selected' : ''}>Low Power Mode</option>
              </select>
            </div>
            
          </div>
          
    </div>
    `
  }

  const supportedTypes = ["EX"];

  if(!supportedTypes.includes(sensor.type)) {
    return "";
  }

  if(Branding.currentBrand === 'AF') {
    return TemplateAF();
  }

  return defaultTemplate();

}

export default SensorSettingsProbe;
